/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Slarequired1Inputs */

const en_cases_settings_slarequired1 = /** @type {(inputs: Cases_Settings_Slarequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An SLA target is required`)
};

/**
* | output |
* | --- |
* | "An SLA target is required" |
*
* @param {Cases_Settings_Slarequired1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_slarequired1 = /** @type {((inputs?: Cases_Settings_Slarequired1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Slarequired1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_slarequired1(inputs)
});
export { cases_settings_slarequired1 as "cases_settings_slaRequired" }